import type { ProjectSummary } from "../types";
import { escapeHtml, getProjectStatusLabel, renderPagePath } from "../view-helpers";

export function renderProjectHomePage(
  project: ProjectSummary,
  pendingCount: number,
): string {
  return `
    <section class="screen">
      <header class="topbar">
        <button class="ghost-button" data-action="back-to-list">项目列表</button>
        <h1>项目首页</h1>
      </header>
      ${renderPagePath([{ label: project.name }])}
      <div class="panel stack">
        <p class="eyebrow">当前项目</p>
        <h2>${escapeHtml(project.name)}</h2>
        <button class="ghost-button small-button" type="button" data-action="rename-project">修改项目标题</button>
        <p class="muted">状态：${getProjectStatusLabel(project.status)}</p>
        <p class="muted">创建人：${escapeHtml(project.creatorUserName || "未记录")}</p>
        <div class="inline-pills">
          <span class="state-pill">本机自动保存</span>
          <span class="state-pill">最近修改：${new Date(project.updatedAt).toLocaleString("zh-CN")}</span>
        </div>
      </div>
      <div class="panel stack">
        <button class="ghost-button" data-action="sync-project">立即同步</button>
        <button class="nav-button" data-action="go-project-info">项目基本信息</button>
        <button class="nav-button" data-action="go-receiving">项目接件信息</button>
        <button class="nav-button" data-action="go-inspection-items">现场评定</button>
        <button class="nav-button" data-action="go-preview">成品预览与发送</button>
      </div>
    </section>
  `;
}
